import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5515e5f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-header__titleWrap" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "page-header__title" }, "Danh sách tài khoản")
  ])
], -1))
const _hoisted_2 = { class: "p-fluid" }
const _hoisted_3 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_4 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { class: "page-panel" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_DataTable, {
          loading: _ctx.isLoading,
          value: $setup.list,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10,25,50],
          rowHover: true,
          filters: $setup.filters,
          "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters) = $event)),
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          globalFilterFields: ['fullname','username'],
          currentPageReportTemplate: "Có tổng số {totalRecords} tài khoản",
          columnResizeMode: "fit | expand"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-filter-slash",
                label: "Xoá",
                class: "p-button-outlined",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearFilter())),
                style: {"width":"6em"}
              }),
              _createElementVNode("span", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_InputText, {
                  modelValue: $setup.filters['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters['global'].value) = $event)),
                  placeholder: "Tìm theo tên hoặc tài khoản"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          paginatorLeft: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi plus-circle",
              class: "p-button-text",
              onClick: _ctx.loadBook
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "fullname",
              header: "Họ và tên",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "username",
              header: "Tài khoản",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "permission",
              header: "Quyền hạn",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "khoaPhong",
              header: "Khoa/phòng",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "phoneNumber",
              header: "Số điện thoại",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "active",
              header: "Trạng thái",
              sortable: ""
            }, {
              body: _withCtx(({data}) => [
                _createTextVNode(_toDisplayString($setup.activeStatus(data.active)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Chỉnh sửa",
              style: {"width":"100px"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  style: {"text-decoration":"none !important"},
                  to: { name: 'userupdate', params: {id: slotProps.data.id}}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      type: "button",
                      label: "Chỉnh sửa",
                      icon: "pi pi-pencil"
                    })
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value", "filters"])
      ])
    ]),
    _: 1
  }))
}